import axios from 'axios';
import { IAuthorityErrata } from './model/authority-tiles/IAuthorityErrata';
import { TileUrlProvider } from './TileUrlProvider';

export class ErrataProvider {

    static inject = () => [TileUrlProvider];
    constructor(private tileUrlProvider: TileUrlProvider) {}

    getErrata = async () => {
        const errataUrls = await this.tileUrlProvider.getAuthorityErrataUrls();

        const errataResponses = await Promise.all(
            errataUrls.map(errataUrl => axios.get(errataUrl)
                .then(res => res.data as IAuthorityErrata)
                .catch((err: any) => {
                    throw new Error(`failed to GET ${errataUrl}. Got ${err?.response?.status}`);
                }))
        );

        const errata: IAuthorityErrata = {
            'airspace-authority': errataResponses[0]['airspace-authority'],
            adds: [],
            changes: [],
            removes: [],
            errataFor: {},
        };

        for (const errataResponse of errataResponses){
            errata.adds = [...errata.adds, ...errataResponse.adds];
            errata.changes = [...errata.changes, ...errataResponse.changes];
            errata.removes = [...errata.removes, ...errataResponse.removes];
            errata.errataFor = {
                ...errata.errataFor,
                ...errataResponse.errataFor
            };
        }

        return errata;
    };
}
